import React, { useEffect, useState } from "react"
import { Icon, IconClose } from '../../../../base/icons';
import { getLJsonStorage } from "../../../welcome-dashboard/Utils";
import Application from "./app";
import "./style.css";

const GTuner = (props) => {

    const [isDisable, setIsDisable] = useState(false);

    useEffect(() => {
        const app = new Application()
        app.start()
    }, [])


    const { moderator, decodedData, secondModerator, socket, Sessions, closeTool } = props;

    const { openByUser, SessionId } = Sessions;
    useEffect(() => {
        if (!decodedData || (decodedData && !decodedData.student) || secondModerator) {
            setIsDisable(true);
        }

        if (SessionId === openByUser) {
            setIsDisable(true);

        }

        socket.off('guitar_tuner_return');
    }, [openByUser]);

    const isGuestAccount = getLJsonStorage("auth", "guest_id");

    return (<>

        {/* <div className="tool-layer" > */}
            <div className={"tunerpage " + (!isDisable ? "padding-top20" : '')} >
                {isGuestAccount ? "" : (isDisable &&
                    <div
                        id="tunerPage-close-icon-wrapper"
                        className='close-side-bar'
                        onClick={closeTool}
                    >
                        <Icon src={IconClose} containerId="tunerPage-close-icon" />
                    </div>)
                }
                <div className="meter">
                    <div className="meter-dot"></div>
                    <div className="meter-pointer"></div>
                </div>
                <div className="notes">
                    <div className="notes-list"></div>
                    <div className="frequency"> <span>Hz</span></div>
                </div>
            </div>
        {/* </div> */}
    </>)
}

export default GTuner;